module.exports = __webpack_public_path__ + "img/float-logo.12873a10.png";